import en from './en';

const sw = {};

Object.keys(en).forEach(key => {
  sw[key] = `« ${en[key]} »`;
});

export default sw;
